import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownButton } from 'react-bootstrap-5';
import { withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

import ProjectCard from 'components/project/project_card';
import PredictionSummary from './prediction_summary';

export class ListingPrediction extends React.Component {
  static propTypes = {
    editLink: PropTypes.string,
    features: PropTypes.shape({
      backoffice: PropTypes.bool,
      pipeline: PropTypes.bool,
    }).isRequired,
    history: PropTypes.object.isRequired,
    listing: PropTypes.shape({
      daysLikelyToClose: PropTypes.number,
      estimatedGrossCommission: PropTypes.number,
      listingStatus: PropTypes.string.isRequired,
      percentageLikelyToClose: PropTypes.number,
      typeLabel: PropTypes.string.isRequired
    }),
    moveToTab: PropTypes.func,
    showUpdateModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
  };

  goToVoucherTab = (e) => {
    if (e) e.preventDefault();

    this.props.history.push('/vouchers');
  }

  predictionCardAction() {
    const { editLink, features, listing, moveToTab, showUpdateModal } = this.props;
    const { backoffice, pipeline } = features;
    const closed = listing.listingStatus === 'closed';

    const items = [];
    if (backoffice && (!closed || moveToTab)) {
      items.push(
        <Dropdown.Item key="vouchers-tab" name="go-to-vouchers" onClick={this.goToVoucherTab}>Go To Vouchers</Dropdown.Item>
      );
    }
    if ((backoffice && !closed) || pipeline) {
      items.push(
        <Dropdown.Item key="modal" name="update-prediction-link" onClick={showUpdateModal}>
          Update{closed ? '' : ' Prediction'}
        </Dropdown.Item>
      );
    }

    items.push(
      <Dropdown.Item href={`${editLink}#saleFields`} key="edit-link" name="edit-listing-link">
        Edit {listing.typeLabel}
      </Dropdown.Item>
    );

    return (
      <DropdownButton id={`listing-menu-${listing.id}`} title={<FontAwesomeIcon icon={faEllipsisV} />} variant="ghost btn-icon">
        {items}
      </DropdownButton>
    );
  }

  render() {
    return (
      <ProjectCard bare name={this.props.title} rightActions={[this.predictionCardAction()]} wrapBody>
        <PredictionSummary {...this.props.listing} />
      </ProjectCard>
    );
  }
}

export default withRouter(ListingPrediction);
